export default "__VITE_ASSET__D6FQA83w__"